import { Component } from '@angular/core';
import { SplashScreenService } from '../common/splash-screen.service';
import { ActivatedRoute } from '@angular/router';

enum WarningType {
  PRODUCT = 'product',
  CUSTOMER = 'customer',
  LOCATION = 'location',
}

@Component({
  selector: 'app-warning',
  templateUrl: './warning.component.html',
  styleUrls: ['./warning.component.scss'],
})
export class WarningComponent {
  private warningType: WarningType;
  warningMessage: string;

  constructor(
    private splashScreenService: SplashScreenService,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe((params) => {
      this.warningType = params.warningType || WarningType.PRODUCT;
      if (this.warningType === WarningType.PRODUCT) {
        this.warningMessage =
          'Our system has detected unusual activity on this product and determined it may not be genuine.';
      } else if (this.warningType === WarningType.CUSTOMER) {
        this.warningMessage =
          ' Our system has detected an unusual activity from this device. Please try again later.';
      } else if (this.warningType === WarningType.LOCATION) {
        this.warningMessage =
          ' This experience is not available in your location. If you are using a VPN please select your own country or try disabling it.';
      }
    });
  }

  ngAfterViewInit() {
    this.splashScreenService.hide();
  }
}
